import { supabase } from '../../lib/supabase'

export type AvailabilityDecisionKind = 'approve' | 'return' | 'deny'

export type DecideAvailabilityExceptionParams = {
  exceptionId: string
  decision: AvailabilityDecisionKind
  comment?: string
}

// The only path to approve, return, or deny an exception:
// v1-decide-availability-exception records the decision and moves the
// exception's state in one transaction while holding the service role.
// Returns whether it landed.
export async function decideAvailabilityException(params: DecideAvailabilityExceptionParams): Promise<boolean> {
  const { error } = await supabase.functions.invoke('v1-decide-availability-exception', { body: params })
  return !error
}
